interface GetBannerSlideStyleParams {
  isSingleSlidePerView: boolean
  isMobile: boolean
  isImageSizeLarge: boolean
}

export function getBannerSlideStyle({ isSingleSlidePerView, isMobile, isImageSizeLarge }: GetBannerSlideStyleParams) {
  let height
  if (isSingleSlidePerView) {
    height = isMobile ? 'auto' : '240px'
  } else if (isMobile) {
    height = '120px'
  } else {
    height = isImageSizeLarge ? '200px' : '135px'
  }

  return { height, aspectRatio: isSingleSlidePerView && isMobile ? '2.67' : 'auto' }
}
